import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { StaffService } from 'src/app/services/staff/staff.service';
import { FilterService } from 'src/app/services/filter.service';
import { TimeSheetService } from 'src/app/services/time-sheet.service';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);
import * as _ from 'lodash';
import { saveAs } from "file-saver";

@Component({
  selector: 'app-admin-report-a',
  templateUrl: './admin-report-a.component.html',
  styleUrls: ['./admin-report-a.component.scss']
})
export class AdminReportAComponent implements OnInit {
  selectedDate: any;
  sort: MatSort;
  paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  searchText;
  today = new Date()

  displayedColumns: string[] = ['Instructor', 'nightShift', 'LogIn', 'LunchStart', 'LunchEnd', 'LogOut', 'WorkHours', 'TravelHours', 'Total'];
  allInstrutorsLogs: any;
  displayMsg: boolean;
  loading: boolean = false;
  isPrint: boolean;
  allInstrutors: any;
  tempInst: any = [];
  finalList: any = [];
  afterFilter: any;
  allInstructorsCopy: any;
  filterActive: boolean = false;
  noDataMsg = {
    title: "No Logs!",
    data: "No instructors have yet loged their time"
  }

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  @HostListener('window:beforeprint', ['$event'])
  onBeforePrint(event) {
    // this.isPrint = true
    $('th').addClass('printTableHeader')
    // this.print.emit({ msg: 'printing' })
    // this.displayedColumns = ['date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours'];
    // this.dataSource.paginator = null;
  }

  @HostListener('window:afterprint', ['$event'])
  onAfterPrint(event) {
    // this.isPrint = false
    $('th').removeClass('printTableHeader')
    // this.print.emit({ msg: 'printing complete' })
    // this.displayedColumns = ['copyPaste', 'date', 'logIn', 'lunchStart', 'lunchEnd', 'logOut', 'travelHours', 'hoursWorked', 'totalHours', 'edit'];
    // this.dataSource.paginator = this.paginator;
  }
  constructor(private _staffService: StaffService, public _filter: FilterService, public _timeSheetService: TimeSheetService) {
    this.dataSource = new MatTableDataSource<any>();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnInit() {
    this.dataSource.sort = this.sort;
    this.loading = true;
    this.displayMsg = false
    this.selectedDate = moment().format("MM/DD/YYYY")
    this.getInstructorTime(this.selectedDate)
    this.getAllInstructors()
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  dateChanged(event) {
    this.displayMsg = false
    this.dataSource = new MatTableDataSource()
    console.log("event", event);
    this.selectedDate = event
    console.log("this.selectedDate", this.selectedDate);
    this.getInstructorTime(this.selectedDate)
  }



  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.updateData(this.allInstrutorsLogs)
    } else {
      let filteredInstructor = [];
      this.allInstrutorsLogs.forEach((e1) => {
        if (e1.instructor.name.toString().toLowerCase().includes(searchText.toString().toLowerCase())) {
          filteredInstructor.push(e1)
        }
      })
      this.updateData(filteredInstructor)
      if (filteredInstructor.length <= 0) {
        this.afterFilter = {
          title: "No Logs!",
          data: "Sorry, no instructors matched your search"
        }
      }
    }
  }

  updateData(logs) {
    console.log("Update data called in admin report a", logs)
    this.dataSource = new MatTableDataSource(logs);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("inside switch case", item, property);
      switch (property) {
        case 'instructor.name': return item.instructor.name;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    console.log("After Update data called in admin report a", this.dataSource)
  }
  getFinalList() {
    if (this.tempInst.length > 0 && this.allInstrutors) {

      let filteredArray = _.differenceBy(this.allInstrutors, this.tempInst, '_id');
      console.log("this function is called or not", filteredArray);
      if (filteredArray.length > 0) {
        filteredArray.forEach(item => {
          let data = {
            date: this.selectedDate,
            instructor: item,
            logIn: '00:00',
            logOut: '00:00',
            lunchStart: '00:00',
            lunchEnd: '00:00',
            totalHours: { hours: '00', minutes: '00' },
            travel: "00:00",
            workingHours: { hours: '00', minutes: '00' }
          }
          this.allInstrutorsLogs.push(data)
        })
        this.allInstrutorsLogs.sort((a, b) => a.instructor.name.localeCompare(b.instructor.name))

        console.log('this.allInstrutorsLogs===========>', this.allInstrutorsLogs);


        this.updateData(this.allInstrutorsLogs)
      }
    }
  }

  // API
  getAllInstructors() {
    let getTwoArray = false
    this._staffService.getInstructors(getTwoArray).subscribe(instructorsResponse => {
      console.log("instructorsResponse", instructorsResponse)
      this.allInstrutors = instructorsResponse;
      this.allInstructorsCopy = instructorsResponse;
      this.getFinalList()
      // this.dataSource = new MatTableDataSource<any>(this.allInstrutors)
    })
  }
  getInstructorTime(date) {
    let data = {
      date: date
    }
    this._timeSheetService.getMultipleInstructorTime(data).subscribe(instLogs => {

      console.log("value when date is changed", instLogs);


      this.loading = false;
      this.allInstrutorsLogs = instLogs.response;
      if (this.allInstrutorsLogs.length == 0) { this.displayMsg = true; return; }
      this.allInstrutorsLogs.forEach(item => {
        this.tempInst.push(item.instructor)
      })
      console.log("---this.allInstrutorsLogs---", this.allInstrutorsLogs, this.tempInst);
      this.updateData(this.allInstrutorsLogs)
      // this.getFinalList()
    })
  }

  someMethod(event) {
    console.log("sort in admin report a", event)
  }

  padZero(value) {
    const digit = value.split(':');
    let data = String(this.pad(digit[0])) + ':' + String(this.pad(digit[1]));
    return data;
  }

  pad(value) {
    if (Number(value) < 10 && value.length != 2) {
      return '0' + value;
    } else {
      return value;
    }
  }

  printAdminReportA() {
    console.log('Print Report===>', this.allInstrutorsLogs);
    this.loading = true;
    let data = {
      selectedDate: this.selectedDate,
      logs: this.allInstrutorsLogs
    }
    this._timeSheetService.generatePdfReportA(data).subscribe(res => {
      console.log('Res===>', res);
      this.saveToFileSystem(res);
    }, err => {
      console.log('Error while pdf generate', err);
      this.loading = false;
    })
  }
  checkTotalWorkHour(hours, minutes) {
    // console.log("***checkTotalWorkHour", hours, minutes);
    if (hours > 11 && minutes > 0) {
      // console.log("***checkTotalWorkHour", "hours", hours, "minutes", minutes);
      return 'break';
    } if (hours == 12 && minutes == 0) {
      return 'ok';
    }
    else {
      return 'ok';
    }
  }

  private saveToFileSystem(response) {
    let byteArray = new Uint8Array(response.data);
    let blob = new Blob([byteArray], { type: 'application/pdf' });
    saveAs(blob, this.selectedDate);
    this.loading = false;
  }


}

// Time logs for ALL Instructors at a given date... API?
